export default __webpack_public_path__ + "static/media/map-aboutUs.ca91afda.png";